import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useCallback, useEffect, useState } from "react";

/**
 * useLotteryAmount - 获取抽奖所需金额 Hook
 * 
 * 用于调用 Lottery 合约的 lotteryAmount 方法获取参与抽奖所需的主网币数量。
 * 
 * @returns {Object} 返回获取方法、金额和加载状态
 *   - getLotteryAmount: 执行获取抽奖金额的函数
 *   - lotteryAmount: 抽奖所需金额（bigint）
 *   - lotteryAmountLod: 加载状态
 */
const useLotteryAmount = () => {
    // 存放数据
    const [lotteryAmount, setLotteryAmount] = useState<bigint>(BigInt(0));
    // loading
    const [lotteryAmountLod, setLoading] = useState(false);
    // 获取合约实例
    const { contractEvm: { Lottery } } = useConnectWallet();

    /**
     * 获取抽奖所需金额
     * @returns 返回抽奖所需金额（bigint）
     */
    const getLotteryAmount = useCallback(async () => {
        setLoading(true);
        if (Lottery) {
            try {
                // 调用合约的 lotteryAmount 方法
                const amount = await Lottery.lotteryAmount();
                // 保存金额
                setLotteryAmount(amount);
                setLoading(false);
                return amount;
            } catch (e) {
                console.log("useLotteryAmount", e);
                setLoading(false);
                return BigInt(0);
            }
        }
        setLoading(false);
        return BigInt(0);
    }, [Lottery]);
    useEffect(() => {
        getLotteryAmount()
    }, [getLotteryAmount])
    return { getLotteryAmount, lotteryAmount, lotteryAmountLod };
};

export default useLotteryAmount;
